import { render, staticRenderFns } from "./EditThresholdsModal.vue?vue&type=template&id=eb6dbc14&scoped=true&"
import script from "./EditThresholdsModal.vue?vue&type=script&lang=js&"
export * from "./EditThresholdsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6dbc14",
  null
  
)

export default component.exports